module.exports = {
      id: "success-usage",
      viewBox: "0 0 82 82",
      url: __webpack_public_path__ + "svg-sprite-5579a9c22c9b0e56875750544888299d.svg#success",
      toString: function () {
        return this.url;
      }
    }